import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";
import { categories } from "@/mocks/categories";
import { specials } from "@/mocks/specials";
import { siteInfo } from "@/mocks/site";

export default function SiteIntro() {
  const reviewCount = specials.reduce((total, special) => total + special.articles.length, 0);

  const stats = [
    { value: `${movies.length}`, label: "精选影片", icon: "ri-film-line" },
    { value: `${categories.length}`, label: "电影类型", icon: "ri-apps-2-line" },
    { value: `${reviewCount}`, label: "深度影评", icon: "ri-quill-pen-line" },
    { value: "每日", label: "资讯更新", icon: "ri-refresh-line" },
  ];

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
        <div>
          <p className="mb-2 font-label text-xs uppercase tracking-[0.25em] text-primary-400">About Us</p>
          <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-3xl">
            懂电影，更懂想看好电影的你
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-300 md:text-base">{siteInfo.description}</p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-400 md:text-base">{siteInfo.intro}</p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 font-label text-sm uppercase tracking-wide text-foreground-950 transition-colors hover:bg-primary-400"
            >
              <i className="ri-information-line text-lg" />
              了解更多
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300/60 px-6 py-3 font-label text-sm uppercase tracking-wide text-foreground-100 transition-colors hover:border-primary-400 hover:text-primary-400"
            >
              <i className="ri-search-line text-lg" />
              开始搜索
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-200/60 bg-background-100 p-5 md:p-6"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-400">
                <i className={`${stat.icon} text-xl`} />
              </span>
              <p className="mt-4 font-heading text-3xl font-black text-foreground-50">{stat.value}</p>
              <p className="mt-1 text-xs text-foreground-400 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}